var _excluded = ["oldState", "newState"];

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

// src/events.ts
var ToggleEvent = /*#__PURE__*/function (_Event) {
  _inherits(ToggleEvent, _Event);

  var _super = _createSuper(ToggleEvent);

  function ToggleEvent(type) {
    var _this;

    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var _ref$oldState = _ref.oldState,
        oldState = _ref$oldState === void 0 ? "" : _ref$oldState,
        _ref$newState = _ref.newState,
        newState = _ref$newState === void 0 ? "" : _ref$newState,
        init = _objectWithoutProperties(_ref, _excluded);

    _classCallCheck(this, ToggleEvent);

    _this = _super.call(this, type, init);
    _this.oldState = void 0;
    _this.newState = void 0;
    _this.oldState = String(oldState || "");
    _this.newState = String(newState || "");
    return _this;
  }

  return _createClass(ToggleEvent);
}( /*#__PURE__*/_wrapNativeSuper(Event));

var popoverToggleTaskQueue = /* @__PURE__ */new WeakMap();

function queuePopoverToggleEventTask(element, oldState, newState) {
  popoverToggleTaskQueue.set(element, setTimeout(function () {
    if (!popoverToggleTaskQueue.has(element)) return;
    element.dispatchEvent(new ToggleEvent("toggle", {
      cancelable: false,
      oldState: oldState,
      newState: newState
    }));
  }, 0));
} // src/popover-helpers.ts


var ShadowRoot = globalThis.ShadowRoot || function () {};

var HTMLDialogElement = globalThis.HTMLDialogElement || function () {};

var topLayerElements = /* @__PURE__ */new WeakMap();
var autoPopoverList = /* @__PURE__ */new WeakMap();
var visibilityState = /* @__PURE__ */new WeakMap();

function getPopoverVisibilityState(popover) {
  return visibilityState.get(popover) || "hidden";
}

var popoverInvoker = /* @__PURE__ */new WeakMap();

function popoverTargetAttributeActivationBehavior(element) {
  var popover = element.popoverTargetElement;

  if (!(popover instanceof HTMLElement)) {
    return;
  }

  var visibility = getPopoverVisibilityState(popover);

  if (element.popoverTargetAction === "show" && visibility === "showing") {
    return;
  }

  if (element.popoverTargetAction === "hide" && visibility === "hidden") return;

  if (visibility === "showing") {
    hidePopover(popover, true, true);
  } else if (checkPopoverValidity(popover, false)) {
    popoverInvoker.set(popover, element);
    showPopover(popover);
  }
}

function checkPopoverValidity(element, expectedToBeShowing) {
  if (element.popover !== "auto" && element.popover !== "manual") {
    return false;
  }

  if (!element.isConnected) return false;

  if (expectedToBeShowing && getPopoverVisibilityState(element) !== "showing") {
    return false;
  }

  if (!expectedToBeShowing && getPopoverVisibilityState(element) !== "hidden") {
    return false;
  }

  if (element instanceof HTMLDialogElement && element.hasAttribute("open")) {
    return false;
  }

  if (document.fullscreenElement === element) return false;
  return true;
}

function getStackPosition(popover) {
  if (!popover) return 0;
  return Array.from(autoPopoverList.get(popover.ownerDocument) || []).indexOf(popover) + 1;
}

function topMostClickedPopover(target) {
  var clickedPopover = nearestInclusiveOpenPopover(target);
  var invokerPopover = nearestInclusiveTargetPopoverForInvoker(target);

  if (getStackPosition(clickedPopover) > getStackPosition(invokerPopover)) {
    return clickedPopover;
  }

  return invokerPopover;
}

function topMostAutoPopover(document2) {
  var documentPopovers = autoPopoverList.get(document2);

  var _iterator = _createForOfIteratorHelper(documentPopovers || []),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var popover = _step.value;

      if (!popover.isConnected) {
        documentPopovers.delete(popover);
      } else {
        return popover;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return null;
}

function getRootNode(node) {
  if (typeof node.getRootNode === "function") {
    return node.getRootNode();
  }

  if (node.parentNode) return getRootNode(node.parentNode);
  return node;
}

function nearestInclusiveOpenPopover(node) {
  while (node) {
    if (node instanceof HTMLElement && node.popover === "auto" && visibilityState.get(node) === "showing") {
      return node;
    }

    node = node instanceof Element && node.assignedSlot || node.parentElement || getRootNode(node);
    if (node instanceof ShadowRoot) node = node.host;
    if (node instanceof Document) return;
  }
}

function nearestInclusiveTargetPopoverForInvoker(node) {
  while (node) {
    var nodePopover = node.popoverTargetElement;
    if (nodePopover instanceof HTMLElement) return nodePopover;
    node = node.parentElement || getRootNode(node);
    if (node instanceof ShadowRoot) node = node.host;
    if (node instanceof Document) return;
  }
}

function topMostPopoverAncestor(newPopover) {
  var popoverPositions = /* @__PURE__ */new Map();
  var i = 0;

  var _iterator2 = _createForOfIteratorHelper(autoPopoverList.get(newPopover.ownerDocument) || []),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var popover = _step2.value;
      popoverPositions.set(popover, i);
      i += 1;
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  popoverPositions.set(newPopover, i);
  i += 1;
  var topMostPopoverAncestor2 = null;

  function checkAncestor(candidate) {
    var candidateAncestor = nearestInclusiveOpenPopover(candidate);
    if (candidateAncestor === null) return null;
    var candidatePosition = popoverPositions.get(candidateAncestor);

    if (topMostPopoverAncestor2 === null || popoverPositions.get(topMostPopoverAncestor2) < candidatePosition) {
      topMostPopoverAncestor2 = candidateAncestor;
    }
  }

  checkAncestor(newPopover.parentElement || getRootNode(newPopover));
  return topMostPopoverAncestor2;
}

function isFocusable(focusTarget) {
  if (focusTarget.hidden || focusTarget instanceof ShadowRoot) return false;

  if (focusTarget instanceof HTMLButtonElement || focusTarget instanceof HTMLInputElement || focusTarget instanceof HTMLSelectElement || focusTarget instanceof HTMLTextAreaElement || focusTarget instanceof HTMLOptGroupElement || focusTarget instanceof HTMLOptionElement || focusTarget instanceof HTMLFieldSetElement) {
    if (focusTarget.disabled) return false;
  }

  if (focusTarget instanceof HTMLInputElement && focusTarget.type === "hidden") {
    return false;
  }

  if (focusTarget instanceof HTMLAnchorElement && focusTarget.href === "") {
    return false;
  }

  return typeof focusTarget.tabIndex === "number" && focusTarget.tabIndex !== -1;
}

function focusDelegate(focusTarget) {
  if (focusTarget.shadowRoot && focusTarget.shadowRoot.delegatesFocus !== true) {
    return null;
  }

  var whereToLook = focusTarget;

  if (whereToLook.shadowRoot) {
    whereToLook = whereToLook.shadowRoot;
  }

  var autoFocusDelegate = whereToLook.querySelector("[autofocus]");

  if (autoFocusDelegate) {
    return autoFocusDelegate;
  } else {
    var slots = whereToLook.querySelectorAll("slot");

    var _iterator3 = _createForOfIteratorHelper(slots),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var slot = _step3.value;
        var assignedElements = slot.assignedElements({
          flatten: true
        });

        var _iterator4 = _createForOfIteratorHelper(assignedElements),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var el = _step4.value;

            if (el.hasAttribute("autofocus")) {
              return el;
            } else {
              autoFocusDelegate = el.querySelector("[autofocus]");

              if (autoFocusDelegate) {
                return autoFocusDelegate;
              }
            }
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }

  var walker = focusTarget.ownerDocument.createTreeWalker(whereToLook, NodeFilter.SHOW_ELEMENT);
  var descendant = walker.currentNode;

  while (descendant) {
    if (isFocusable(descendant)) {
      return descendant;
    }

    descendant = walker.nextNode();
  }
}

function popoverFocusingSteps(subject) {
  var _focusDelegate;

  (_focusDelegate = focusDelegate(subject)) === null || _focusDelegate === void 0 ? void 0 : _focusDelegate.focus();
}

var previouslyFocusedElements = /* @__PURE__ */new WeakMap();

function showPopover(element) {
  if (!checkPopoverValidity(element, false)) {
    return;
  }

  var document2 = element.ownerDocument;

  if (!element.dispatchEvent(new ToggleEvent("beforetoggle", {
    cancelable: true,
    oldState: "closed",
    newState: "open"
  }))) {
    return;
  }

  if (!checkPopoverValidity(element, false)) {
    return;
  }

  var shouldRestoreFocus = false;

  if (element.popover === "auto") {
    var originalType = element.getAttribute("popover");
    var ancestor = topMostPopoverAncestor(element) || document2;
    hideAllPopoversUntil(ancestor, false, true);

    if (originalType !== element.getAttribute("popover") || !checkPopoverValidity(element, false)) {
      return;
    }
  }

  if (!topMostAutoPopover(document2)) {
    shouldRestoreFocus = true;
  }

  previouslyFocusedElements.delete(element);
  var originallyFocusedElement = document2.activeElement;
  element.classList.add(":popover-open");
  visibilityState.set(element, "showing");

  if (!topLayerElements.has(document2)) {
    topLayerElements.set(document2, /* @__PURE__ */new Set());
  }

  topLayerElements.get(document2).add(element);
  popoverFocusingSteps(element);

  if (element.popover === "auto") {
    if (!autoPopoverList.has(document2)) {
      autoPopoverList.set(document2, /* @__PURE__ */new Set());
    }

    autoPopoverList.get(document2).add(element);
    setInvokerAriaExpanded(popoverInvoker.get(element), true);
  }

  if (shouldRestoreFocus && originallyFocusedElement && element.popover === "auto") {
    previouslyFocusedElements.set(element, originallyFocusedElement);
  }

  queuePopoverToggleEventTask(element, "closed", "open");
}

function hidePopover(element) {
  var _topLayerElements$get, _autoPopoverList$get;

  var focusPreviousElement = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var fireEvents = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (!checkPopoverValidity(element, true)) {
    return;
  }

  var document2 = element.ownerDocument;

  if (element.popover === "auto") {
    hideAllPopoversUntil(element, focusPreviousElement, fireEvents);

    if (!checkPopoverValidity(element, true)) {
      return;
    }
  }

  setInvokerAriaExpanded(popoverInvoker.get(element), false);
  popoverInvoker.delete(element);

  if (fireEvents) {
    element.dispatchEvent(new ToggleEvent("beforetoggle", {
      oldState: "open",
      newState: "closed"
    }));

    if (!checkPopoverValidity(element, true)) {
      return;
    }
  }

  (_topLayerElements$get = topLayerElements.get(document2)) === null || _topLayerElements$get === void 0 ? void 0 : _topLayerElements$get.delete(element);
  (_autoPopoverList$get = autoPopoverList.get(document2)) === null || _autoPopoverList$get === void 0 ? void 0 : _autoPopoverList$get.delete(element);
  element.classList.remove(":popover-open");
  visibilityState.set(element, "hidden");

  if (fireEvents) {
    queuePopoverToggleEventTask(element, "open", "closed");
  }

  var previouslyFocusedElement = previouslyFocusedElements.get(element);

  if (previouslyFocusedElement) {
    previouslyFocusedElements.delete(element);

    if (focusPreviousElement) {
      previouslyFocusedElement.focus();
    }
  }
}

function closeAllOpenPopovers(document2) {
  var focusPreviousElement = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var fireEvents = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var popover = topMostAutoPopover(document2);

  while (popover) {
    hidePopover(popover, focusPreviousElement, fireEvents);
    popover = topMostAutoPopover(document2);
  }
}

function hideAllPopoversUntil(endpoint, focusPreviousElement, fireEvents) {
  var document2 = endpoint.ownerDocument || endpoint;

  if (endpoint instanceof Document) {
    return closeAllOpenPopovers(document2, focusPreviousElement, fireEvents);
  }

  var lastToHide = null;
  var foundEndpoint = false;

  var _iterator5 = _createForOfIteratorHelper(autoPopoverList.get(document2) || []),
      _step5;

  try {
    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
      var popover = _step5.value;

      if (popover === endpoint) {
        foundEndpoint = true;
      } else if (foundEndpoint) {
        lastToHide = popover;
        break;
      }
    }
  } catch (err) {
    _iterator5.e(err);
  } finally {
    _iterator5.f();
  }

  if (!foundEndpoint) {
    return closeAllOpenPopovers(document2, focusPreviousElement, fireEvents);
  }

  while (lastToHide && getPopoverVisibilityState(lastToHide) === "showing" && (_autoPopoverList$get2 = autoPopoverList.get(document2)) !== null && _autoPopoverList$get2 !== void 0 && _autoPopoverList$get2.size) {
    var _autoPopoverList$get2;

    hidePopover(lastToHide, focusPreviousElement, fireEvents);
  }
}

var popoverPointerDownTargets = /* @__PURE__ */new WeakMap();

function lightDismissOpenPopovers(event) {
  if (!event.isTrusted) return;
  var target = event.composedPath()[0];
  if (!target) return;
  var document2 = target.ownerDocument;
  var topMostPopover = topMostAutoPopover(document2);
  if (!topMostPopover) return;
  var ancestor = topMostClickedPopover(target);

  if (ancestor && event.type === "pointerdown") {
    popoverPointerDownTargets.set(document2, ancestor);
  } else if (event.type === "pointerup") {
    var sameTarget = popoverPointerDownTargets.get(document2) === ancestor;
    popoverPointerDownTargets.delete(document2);

    if (sameTarget) {
      hideAllPopoversUntil(ancestor || document2, false, true);
    }
  }
}

var initialAriaExpandedValue = /* @__PURE__ */new WeakMap();

function setInvokerAriaExpanded(el) {
  var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (!el) return;

  if (!initialAriaExpandedValue.has(el)) {
    initialAriaExpandedValue.set(el, el.getAttribute("aria-expanded"));
  }

  var popover = el.popoverTargetElement;

  if (popover instanceof HTMLElement && popover.popover === "auto") {
    el.setAttribute("aria-expanded", String(force));
  } else {
    var initialValue = initialAriaExpandedValue.get(el);

    if (!initialValue) {
      el.removeAttribute("aria-expanded");
    } else {
      el.setAttribute("aria-expanded", initialValue);
    }
  }
} // src/popover.ts


var ShadowRoot2 = globalThis.ShadowRoot || function () {};

function isSupported() {
  return typeof HTMLElement !== "undefined" && _typeof(HTMLElement.prototype) === "object" && "popover" in HTMLElement.prototype;
}

function patchSelectorFn(object, name, mapper) {
  var original = object[name];
  Object.defineProperty(object, name, {
    value: function value(selector) {
      return original.call(this, mapper(selector));
    }
  });
}

var nonEscapedPopoverSelector = /(^|[^\\]):popover-open\b/g;

function hasLayerSupport() {
  return typeof globalThis.CSSLayerBlockRule === "function";
}

function getStyles() {
  var useLayer = hasLayerSupport();
  return "\n".concat(useLayer ? "@layer popover-polyfill {" : "", "\n  :where([popover]) {\n    position: fixed;\n    z-index: 2147483647;\n    inset: 0;\n    padding: 0.25em;\n    width: fit-content;\n    height: fit-content;\n    border-width: initial;\n    border-color: initial;\n    border-image: initial;\n    border-style: solid;\n    background-color: canvas;\n    color: canvastext;\n    overflow: auto;\n    margin: auto;\n  }\n\n  :where([popover]:not(.\\:popover-open)) {\n    display: none;\n  }\n\n  :where(dialog[popover].\\:popover-open) {\n    display: block;\n  }\n\n  :where(dialog[popover][open]) {\n    display: revert;\n  }\n\n  :where([anchor].\\:popover-open) {\n    inset: auto;\n  }\n\n  :where([anchor]:popover-open) {\n    inset: auto;\n  }\n\n  @supports not (background-color: canvas) {\n    :where([popover]) {\n      background-color: white;\n      color: black;\n    }\n  }\n\n  @supports (width: -moz-fit-content) {\n    :where([popover]) {\n      width: -moz-fit-content;\n      height: -moz-fit-content;\n    }\n  }\n\n  @supports not (inset: 0) {\n    :where([popover]) {\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n    }\n  }\n").concat(useLayer ? "}" : "", "\n");
}

var popoverStyleSheet = null;

function injectStyles(root) {
  var styles = getStyles();

  if (popoverStyleSheet === null) {
    try {
      popoverStyleSheet = new CSSStyleSheet();
      popoverStyleSheet.replaceSync(styles);
    } catch (_unused) {
      popoverStyleSheet = false;
    }
  }

  if (popoverStyleSheet === false) {
    var sheet = document.createElement("style");
    sheet.textContent = styles;

    if (root instanceof Document) {
      root.head.prepend(sheet);
    } else {
      root.prepend(sheet);
    }
  } else {
    root.adoptedStyleSheets = [popoverStyleSheet].concat(_toConsumableArray(root.adoptedStyleSheets));
  }
}

function apply() {
  if (typeof window === "undefined") return;
  window.ToggleEvent = window.ToggleEvent || ToggleEvent;

  function rewriteSelector(selector) {
    var _selector;

    if ((_selector = selector) !== null && _selector !== void 0 && _selector.includes(":popover-open")) {
      selector = selector.replace(nonEscapedPopoverSelector, "$1.\\:popover-open");
    }

    return selector;
  }

  patchSelectorFn(Document.prototype, "querySelector", rewriteSelector);
  patchSelectorFn(Document.prototype, "querySelectorAll", rewriteSelector);
  patchSelectorFn(Element.prototype, "querySelector", rewriteSelector);
  patchSelectorFn(Element.prototype, "querySelectorAll", rewriteSelector);
  patchSelectorFn(Element.prototype, "matches", rewriteSelector);
  patchSelectorFn(Element.prototype, "closest", rewriteSelector);
  patchSelectorFn(DocumentFragment.prototype, "querySelectorAll", rewriteSelector);
  Object.defineProperties(HTMLElement.prototype, {
    popover: {
      enumerable: true,
      configurable: true,
      get: function get() {
        if (!this.hasAttribute("popover")) return null;
        var value = (this.getAttribute("popover") || "").toLowerCase();
        if (value === "" || value == "auto") return "auto";
        return "manual";
      },
      set: function set(value) {
        this.setAttribute("popover", value);
      }
    },
    showPopover: {
      enumerable: true,
      configurable: true,
      value: function value() {
        showPopover(this);
      }
    },
    hidePopover: {
      enumerable: true,
      configurable: true,
      value: function value() {
        hidePopover(this, true, true);
      }
    },
    togglePopover: {
      enumerable: true,
      configurable: true,
      value: function value(force) {
        if (visibilityState.get(this) === "showing" && force === void 0 || force === false) {
          hidePopover(this, true, true);
        } else if (force === void 0 || force === true) {
          showPopover(this);
        }
      }
    }
  });
  var originalAttachShadow = Element.prototype.attachShadow;

  if (originalAttachShadow) {
    Object.defineProperties(Element.prototype, {
      attachShadow: {
        enumerable: true,
        configurable: true,
        writable: true,
        value: function value(options) {
          var shadowRoot = originalAttachShadow.call(this, options);
          injectStyles(shadowRoot);
          return shadowRoot;
        }
      }
    });
  }

  var originalAttachInternals = HTMLElement.prototype.attachInternals;

  if (originalAttachInternals) {
    Object.defineProperties(HTMLElement.prototype, {
      attachInternals: {
        enumerable: true,
        configurable: true,
        writable: true,
        value: function value() {
          var internals = originalAttachInternals.call(this);

          if (internals.shadowRoot) {
            injectStyles(internals.shadowRoot);
          }

          return internals;
        }
      }
    });
  }

  var popoverTargetAssociatedElements = /* @__PURE__ */new WeakMap();

  function applyPopoverInvokerElementMixin(ElementClass) {
    Object.defineProperties(ElementClass.prototype, {
      popoverTargetElement: {
        enumerable: true,
        configurable: true,
        set: function set(targetElement) {
          if (targetElement === null) {
            this.removeAttribute("popovertarget");
            popoverTargetAssociatedElements.delete(this);
          } else if (!(targetElement instanceof Element)) {
            throw new TypeError("popoverTargetElement must be an element or null");
          } else {
            this.setAttribute("popovertarget", "");
            popoverTargetAssociatedElements.set(this, targetElement);
          }
        },
        get: function get() {
          if (this.localName !== "button" && this.localName !== "input") {
            return null;
          }

          if (this.localName === "input" && this.type !== "reset" && this.type !== "image" && this.type !== "button") {
            return null;
          }

          if (this.disabled) {
            return null;
          }

          if (this.form && this.type === "submit") {
            return null;
          }

          var targetElement = popoverTargetAssociatedElements.get(this);

          if (targetElement && targetElement.isConnected) {
            return targetElement;
          } else if (targetElement && !targetElement.isConnected) {
            popoverTargetAssociatedElements.delete(this);
            return null;
          }

          var root = getRootNode(this);
          var idref = this.getAttribute("popovertarget");

          if ((root instanceof Document || root instanceof ShadowRoot2) && idref) {
            return root.getElementById(idref) || null;
          }

          return null;
        }
      },
      popoverTargetAction: {
        enumerable: true,
        configurable: true,
        get: function get() {
          var value = (this.getAttribute("popovertargetaction") || "").toLowerCase();
          if (value === "show" || value === "hide") return value;
          return "toggle";
        },
        set: function set(value) {
          this.setAttribute("popovertargetaction", value);
        }
      }
    });
  }

  applyPopoverInvokerElementMixin(HTMLButtonElement);
  applyPopoverInvokerElementMixin(HTMLInputElement);

  var handleInvokerActivation = function handleInvokerActivation(event) {
    var composedPath = event.composedPath();
    var target = composedPath[0];

    if (!(target instanceof Element) || target !== null && target !== void 0 && target.shadowRoot) {
      return;
    }

    var root = getRootNode(target);

    if (!(root instanceof ShadowRoot2 || root instanceof Document)) {
      return;
    }

    var invoker = composedPath.find(function (el) {
      var _el$matches;

      return (_el$matches = el.matches) === null || _el$matches === void 0 ? void 0 : _el$matches.call(el, "[popovertargetaction],[popovertarget]");
    });

    if (invoker) {
      popoverTargetAttributeActivationBehavior(invoker);
      event.preventDefault();
      return;
    }
  };

  var onKeydown = function onKeydown(event) {
    var key = event.key;
    var target = event.target;

    if (!event.defaultPrevented && target && (key === "Escape" || key === "Esc")) {
      hideAllPopoversUntil(target.ownerDocument, true, true);
    }
  };

  var addEventListeners = function addEventListeners(root) {
    root.addEventListener("click", handleInvokerActivation);
    root.addEventListener("keydown", onKeydown);
    root.addEventListener("pointerdown", lightDismissOpenPopovers);
    root.addEventListener("pointerup", lightDismissOpenPopovers);
  };

  addEventListeners(document);
  injectStyles(document);
} // src/index.ts


if (!isSupported()) apply();